import React from 'react';
import { makeStyles, Button } from '~/lib/bn-material-ui';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  image: {
    marginTop: '2rem',
    width: '95%', // Adjusted for better layout
    flexGrow: 1,
    backgroundImage: 'url(/images/ProductDemoSplashPage.png)',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
  button: {
    marginBottom: '2rem',
    fontSize: '3rem',
    fontWeight: 'bold',
    backgroundColor: theme.palette.yellow[20],
    color: theme.palette.gray[70],
    borderRadius: '400px',
    padding: '1rem 2rem',
    boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.4)',
    marginTop: theme.spacing(2), // Add some space above the button
  },
}));

export default function ResourcesPage() {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <div className={styles.image} />
      <Button className={styles.button} href={'/inventory'}>
        Launch HD Product Demo!
      </Button>
    </div>
  );
}
